import { c as _c } from "react/compiler-runtime";
import { ProjectCardContent } from "@components/common/project-card/project-card-content";
import { generateProjectDetailsRoute } from "@router/router-helper";
import { isProjectProcessingSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { getTrackProjectDateProps, trackOpenProjectDetails } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { navigateOnPlainClick } from "@utils/ui-utils";
import { useNavigate } from "react-router-dom";
/**
 * Project card component that displays summary information about a project.
 */
export function ProjectCard(t0) {
  const $ = _c(27);
  const {
    companyId,
    project,
    numberOfProjects,
    sortBy,
    isThumbnailLink: t1
  } = t0;
  const isThumbnailLink = t1 === undefined ? false : t1;
  const {
    trackEvent
  } = useTrackEvent();
  const navigate = useNavigate();
  let t2;
  if ($[0] !== project.id) {
    t2 = isProjectProcessingSelector(project.id);
    $[0] = project.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isProjectProcessing = useAppSelector(t2);
  const isThumbnailLinkActive = isThumbnailLink && !isProjectProcessing;
  let t3;
  if ($[2] !== companyId || $[3] !== project.id) {
    t3 = generateProjectDetailsRoute(companyId, project.id);
    $[2] = companyId;
    $[3] = project.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const projectDetailsRoute = t3;
  let t4;
  if ($[5] !== numberOfProjects || $[6] !== project || $[7] !== trackEvent) {
    t4 = function trackOpenDetails(viewMode) {
      trackOpenProjectDetails({
        trackEvent,
        projectId: project.id,
        props: {
          numberOfProjects,
          ...getTrackProjectDateProps(project),
          viewMode
        }
      });
    };
    $[5] = numberOfProjects;
    $[6] = project;
    $[7] = trackEvent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const trackOpenDetails = t4;
  if (isThumbnailLinkActive) {
    let t5;
    if ($[9] !== trackOpenDetails) {
      t5 = () => trackOpenDetails("map");
      $[9] = trackOpenDetails;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== isProjectProcessing || $[12] !== project || $[13] !== projectDetailsRoute || $[14] !== sortBy || $[15] !== t5) {
      t6 = <ProjectCardContent project={project} sortBy={sortBy} isProjectProcessing={isProjectProcessing} thumbnailLinkTo={projectDetailsRoute} onThumbnailClick={t5} />;
      $[11] = isProjectProcessing;
      $[12] = project;
      $[13] = projectDetailsRoute;
      $[14] = sortBy;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t5;
  if ($[17] !== navigate || $[18] !== projectDetailsRoute || $[19] !== trackOpenDetails) {
    t5 = event => {
      trackOpenDetails("cards");
      navigateOnPlainClick(event, () => navigate(projectDetailsRoute));
    };
    $[17] = navigate;
    $[18] = projectDetailsRoute;
    $[19] = trackOpenDetails;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== isProjectProcessing || $[22] !== project || $[23] !== projectDetailsRoute || $[24] !== sortBy || $[25] !== t5) {
    t6 = <ProjectCardContent project={project} sortBy={sortBy} isProjectProcessing={isProjectProcessing} href={projectDetailsRoute} onClick={t5} />;
    $[21] = isProjectProcessing;
    $[22] = project;
    $[23] = projectDetailsRoute;
    $[24] = sortBy;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}